export default "__VITE_ASSET__CGbQxlHr__"